import PasswordToggle from './PasswordToggle';

export default PasswordToggle;
export type { PasswordToggleProps } from './PasswordToggle';
